const getIsNonEmpty = (value: string) => {
  const trimmed = value.trim()
  return trimmed.length > 0
}

export default getIsNonEmpty
